import React from 'react';
import { Box, TextField, FormHelperText } from "@material-ui/core";
import REG_EX from '../../../Helpers/regex';

export const Referencias = ({ objetoModificacion, validacion, validar }) => {

    const handleChange = (e, regex, noupper) => {
        if (e.target.value === '' || (regex && regex?.test(e.target.value) || !regex)) {
            const obj_aux = { ...objetoModificacion.obj };
            if (noupper) {
                obj_aux[e.target.name] = e.target.value;
            } else {
                obj_aux[e.target.name] = e.target.value;
            }
            objetoModificacion.set({ ...obj_aux });
        }
    };

    const checkvalidacion = (campo, validacion) => {
        if (!validar) return '';
        const objetoValidacion = validacion(validar);
        const campos = objetoValidacion[2];
        if (objetoValidacion[0] === true || !(campos instanceof Array) || campos.length === 0) return '';
        return campos.find(item => item.campo === campo)?.texto || '';
    };

    // Estilo común para los inputs de Google Form
    const inputStyleProps = {
        disableUnderline: false,
        className: "bg-transparent text-gray-800 placeholder-gray-400 focus:after:border-blue-600"
    };

    return (
        <Box className="mt-5 w-full max-w-4xl font-sans">
            <h3 className="text-xl font-medium text-gray-800 mb-1">Referencias</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
                <div className="p-4 border-b md:border-b-0 md:border-r border-gray-300">
                    <label className="block text-sm text-gray-800 mb-2">
                        Nombre del pastor: <span className="text-red-600">*</span>
                    </label>
                    <TextField
                        fullWidth
                        name="nombrepastor"
                        value={objetoModificacion.obj?.nombrepastor || ''}
                        placeholder="Tu respuesta"
                        onChange={(e) => handleChange(e, REG_EX.ALPHABETIC)}
                        InputProps={inputStyleProps}
                    />
                    <FormHelperText className="text-red-500">{checkvalidacion('nombrepastor', validacion)}</FormHelperText>
                </div>

                <div className="p-4 border-gray-300">
                    <label className="block text-sm text-gray-800 mb-2">
                        E-mail del pastor: <span className="text-red-600">*</span>
                    </label>
                    <TextField
                        fullWidth
                        name="emailpastor"
                        value={objetoModificacion.obj?.emailpastor || ''}
                        placeholder="Tu respuesta"
                        onChange={(e) => handleChange(e, REG_EX.EMAILCHARS, 'no-uppercase')}
                        InputProps={inputStyleProps}
                    />
                    <FormHelperText className="text-red-500">{checkvalidacion('emailpastor', validacion)}</FormHelperText>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 border-x border-b border-gray-300">
                <div className="p-4 border-b md:border-b-0 md:border-r border-gray-300">
                    <label className="block text-sm text-gray-800 mb-2">
                        Nombre de un anciano/diácono: <span className="text-red-600">*</span>
                    </label>
                    <TextField
                        fullWidth
                        name="nombreanciano"
                        value={objetoModificacion.obj?.nombreanciano || ''}
                        placeholder="Tu respuesta"
                        onChange={(e) => handleChange(e, REG_EX.ALPHABETIC)}
                        InputProps={inputStyleProps}
                    />
                    <FormHelperText className="text-red-500">{checkvalidacion('nombreanciano', validacion)}</FormHelperText>
                </div>

                <div className="p-4 border-gray-300">
                    <label className="block text-sm text-gray-800 mb-2">
                        E-mail de un anciano/diácono: <span className="text-red-600">*</span>
                    </label>
                    <TextField
                        fullWidth
                        name="emailanciano"
                        value={objetoModificacion.obj?.emailanciano || ''}
                        placeholder="Tu respuesta"
                        onChange={(e) => handleChange(e, REG_EX.EMAILCHARS, 'no-uppercase')}
                        InputProps={inputStyleProps}
                    />
                    <FormHelperText className="text-red-500">{checkvalidacion('emailanciano', validacion)}</FormHelperText>
                </div>
            </div>

            {((objetoModificacion.obj?.estado_civil?.id === 3 || objetoModificacion.obj?.estado_civil?.id === 6) && objetoModificacion.obj?.conyuge !== '') && (
                <div className="grid grid-cols-1 md:grid-cols-2 border-x border-b border-gray-300 bg-gray-50/50">
                    <div className="p-4 border-b md:border-b-0 md:border-r border-gray-300">
                        <label className="block text-sm text-gray-600 mb-2 font-medium">Nombre del conyuge:</label>
                        <TextField
                            fullWidth
                            disabled
                            title='Por favor complete el nombre de su cónyuge, arriba, en la sección "Información personal" debajo del campo "Estado civil".'
                            value={objetoModificacion.obj?.conyuge || ''}
                            InputProps={{ ...inputStyleProps, disableUnderline: true }}
                            className="bg-gray-100"
                        />
                        <FormHelperText className="text-red-500">{checkvalidacion('nombreconyuge', validacion)}</FormHelperText>
                    </div>

                    <div className="p-4 border-gray-300">
                        <label className="block text-sm text-gray-800 mb-2">
                            E-mail del conyuge: <span className="text-red-600">*</span>
                        </label>
                        <TextField
                            fullWidth
                            name="emailconyuge"
                            value={objetoModificacion.obj?.emailconyuge || ''}
                            placeholder="Tu respuesta"
                            onChange={(e) => handleChange(e, REG_EX.EMAILCHARS, 'no-uppercase')}
                            InputProps={inputStyleProps}
                        />
                        <FormHelperText className="text-red-500">{checkvalidacion('emailconyuge', validacion)}</FormHelperText>
                    </div>
                </div>
            )}
        </Box>
    );
};